/**
 * Activity types for personal reminders (Odoo-style "activities").
 * Type is a light categorization used for filtering and quick reading of
 * the list — it does not change any behavior.
 * i18n labels live under `activities.types.<key>`.
 */
export const ACTIVITY_TYPES = [
  { key: "todo", icon: "fa-thumbtack", color: "#4e73df" },
  { key: "call", icon: "fa-phone", color: "#1cc88a" },
  { key: "email", icon: "fa-envelope", color: "#36b9cc" },
  { key: "meeting", icon: "fa-users", color: "#6f42c1" },
  { key: "order", icon: "fa-shopping-cart", color: "#fd7e14" },
  { key: "followup", icon: "fa-reply", color: "#e83e8c" },
];

export const DEFAULT_ACTIVITY_TYPE = "todo";

export function getActivityType(key) {
  return (
    ACTIVITY_TYPES.find((type) => type.key === key) ||
    ACTIVITY_TYPES.find((type) => type.key === DEFAULT_ACTIVITY_TYPE)
  );
}

export default ACTIVITY_TYPES;
